












































































































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";

import EstimateItem from "../components/EstimateItem.vue";
import EstimateHeader from "../components/EstimateHeader.vue";

import Estimate from "@/usecases/accounting/estimate";
import EstimateItemModel from "@/usecases/accounting/estimate-item";
import VToolbar from "../../common/components/VToolbar.vue";
import EstimateService from "@/usecases/accounting/estimate-service";
import MoveEvent from "../presenters/move-event";
import SelectOption from "@/common/ui/presenters/select-option";
import EstimateApi from "../../../api/accounting/estimate-api";
import { client } from "../../../api/request";
import EstimateStatus from "@/usecases/accounting/estimate-status";
import EstimateStatusTranslater from "@/usecases/accounting/estimate-status-translater";
import UnitApi from "../../../accounting/api/unit-api";
import UnitOption from "../presenters/unit-option";
import PrintApi from "../../../api/accounting/print-api";
import SubmitButton from "@/components/SubmitButton.vue";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import { applyDefaultEstimatePaymentMethod } from "@/helpers/apply-default-estimate-payment-method";
import Decimal from "decimal.js";
import { estimateFromProfitRate } from "@/models/estimate-from-profit-rate";
import {
  EstimateTemplate,
  EstimateTemplateItem
} from "@/api/estimate-templates-api";
import UseEstimateTemplate from "@/components/UseEstimateTemplate.vue";
import { format } from "date-fns";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import ProfitRateModal from "@/components/ProfitRateModal.vue";

const printApi = new PrintApi(client);
const estimateApi = new EstimateApi(client);
const unitApi = new UnitApi(client);
const service = new EstimateService(estimateApi);

@Component({
  components: {
    ProfitRateModal,
    TextTemplateModal,
    UseEstimateTemplate,
    VToolbar,
    EstimateItem,
    EstimateHeader,
    SubmitButton
  }
})
export default class EditEstimatePage extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop({ required: true }) projectId!: number;

  textTemplateModalOpen = false;
  calcFromProfitRateModalOpen = false;
  calcInvoiceFromProfitRateModalOpen = false;
  estimateNumber: string = "";

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    return !(from === "parents" && to === "children" && children > 0);
  }

  get fields(): string[] {
    return [
      "品目",
      "経費カテゴリ",
      "数量",
      "単位",
      "単価",
      "金額",
      "発注単価",
      "発注金額",
      "利益率",
      "備考"
    ];
  }

  estimate = new Estimate();
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  get estimatePaymentMethodSelectOptions() {
    const optsRaw: any[] = (this.estimate as any).estimatePaymentMethods || [];
    const currentRaw: any = (this.estimate as any).paymentMethod;

    const toKey = (v: any) => String(v == null ? "" : v).trim();
    const currentKey = toKey(currentRaw);
    const existingKeys = new Set(optsRaw.map(toKey).filter(k => k !== ""));

    const merged = [...optsRaw];
    if (currentKey !== "" && !existingKeys.has(currentKey)) {
      merged.push(currentRaw);
    }

    const options = merged
      .map(v => ({ value: v, text: toKey(v) }))
      .filter(o => o.text !== "");
    return options;
  }

  printing: boolean = false;

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      try {
        const url = await printApi.getEstimatePrint(
          id,
          this.$store.state.accessToken,
          printsExcludeTax
        );
        window.open(url, "見積書印刷");
      } catch (e) {
        alert("印刷に失敗しました。しばらく待ってから改めてお試しください。");
      } finally {
        this.printing = false;
      }
    } else {
      alert("印刷中です");
    }
  }

  get statusOptions() {
    return EstimateStatus.all().map(value => ({
      value,
      text: EstimateStatusTranslater.toJp(value)
    }));
  }

  goListPage() {
    this.$router.push({ name: "estimates" });
  }

  status = "";

  async save() {
    this.status = "progressing";
    await service.save(this.estimate);
    await this.edit(Number(this.id));
    this.$store.dispatch("getStatusProject");
    // TODO 何かフィードバックした方がいいか？
  }

  async addNewItem() {
    await service.addNewItem(this.estimate);
  }

  async addNewItems(items: number) {
    for (let i = 0; i < items; i++) {
      await service.addNewItem(this.estimate);
    }
  }

  async addNewItemAfter(itemId: string) {
    await service.addNewItemAfter(this.estimate, itemId);
  }

  async removeItem(itemId: string) {
    this.estimate = await service.removeItem(this.estimate, itemId);
  }

  async removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.estimate = await service.removeAllItems(this.estimate);
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(Number(this.id));
    this.goListPage();
    this.$store.dispatch("getStatusProject");
  }

  async calculateTotal() {
    this.estimate = await service.calculateTotal(this.estimate);
  }

  async calculateInvoice(profitRate: number) {
    if (!confirm("発注額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }
    this.estimate.lossRate = new Decimal(1)
      .minus(profitRate)
      .mul(100)
      .toNumber();
    this.estimate = await service.calculateInvoice(this.estimate);
  }

  private editing = false;

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculateTotal();
  }

  protected created() {
    this.edit(Number(this.id));
    this.initUnitList();
    this.initExpenseCategories();
  }

  private async edit(id: number) {
    this.estimate = await service.find(id);
    this.estimateNumber = this.estimate.estimateNumber as string;
    if (!this.estimate.projectId) {
      this.estimate.projectId = this.projectId;
      this.estimate.projectName = this.$store.state.project.name;
    }
    applyDefaultEstimatePaymentMethod(this.estimate);
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  async initExpenseCategories() {
    this.expenseCategories = [
      { id: "", name: "", important: false },
      ...(await getExpenseCategories())
    ];
  }

  async calculateFromProfitRate(profitRate: number) {
    if (!confirm("見積額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }

    // TODO: asしなくても通るように型定義したい
    this.estimate = estimateFromProfitRate(
      this.estimate,
      profitRate
    ) as Estimate;
    this.estimate = await service.calculateTotal(this.estimate);
  }

  /**
   * 既存の項目からテンプレートを作る
   */
  saveTemplate() {
    this.$store.dispatch("estimateTemplate/save", {
      title: "新しいテンプレート " + format(new Date(), "MM/dd HH:mm"),
      items: this.estimate.items
    });
  }

  /**
   * テンプレートを使う
   */
  useTemplate(template: EstimateTemplate): void {
    const items = template.items.map(templateItemToItem);
    items.forEach(item => {
      this.estimate.items.push(item);
    });
    this.calculateTotal();
  }

  addTextToMention(text: string) {
    if (this.estimate.mention) {
      this.estimate.mention += "\n";
    }
    this.estimate.mention += text;
    this.textTemplateModalOpen = false;
  }
}

function templateItemToItem(item: EstimateTemplateItem): EstimateItemModel {
  return {
    ...item,
    totalPrice: 0,
    loss: 0,
    items: (item.items || []).map(n => templateItemToItem(n)),
    purchased: false
  };
}
